import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { middleware as simpleFetchManager } from 'loankeeper-common/helpers/SimpleFetchManager'
import arrayMiddleware from 'loankeeper-common/store/middlewares/array'
import analyticsMiddleware from 'loankeeper-common/store/middlewares/analytics'

import sagas from '../sagas'
import { makePersistantReducer, makePersistor } from './persistor'
import { rootReducer } from './root.reducer'

const isProduction = process.env.NODE_ENV === 'production'

export async function makeStore(deps, state) {
  const sagaMiddleware = createSagaMiddleware()

  const store = configureStore({
    reducer: makePersistantReducer(rootReducer),
    preloadedState: state,
    middleware: [
      arrayMiddleware,
      ...getDefaultMiddleware({
        thunk: {
          extraArgument: deps,
        },
        immutableCheck: false, // TODO: should be enabled in the future
        serializableCheck: false, // TODO: should be enabled in the future
        // serializableCheck: {
        //   ignoredActions: ['persist/PERSIST'],
        // },
      }),
      // thunk.withExtraArgument(deps),
      simpleFetchManager,
      sagaMiddleware,
      analyticsMiddleware,
    ],
    devTools: !isProduction,
  })

  sagaMiddleware.run(sagas)

  await makePersistor(store)

  return store
}

type ThenArg<T> = T extends PromiseLike<infer U> ? U : T

export type ReduxStore = ThenArg<ReturnType<typeof makeStore>>

export type AppDispatch = ReduxStore['dispatch']
